const JavelinaBaseClient = require("./JavelinaBaseClient");

class JavelinaLocationClient extends JavelinaBaseClient {
    constructor(
        javelinaProxyApiUrl = process.env.JAVELINA_PROXY_API_URL, 
        javelinaProxySecretName = process.env.JAVELINA_PROXY_SECRET_NAME || '',
        axiosOptions
    ) {
        super(javelinaProxyApiUrl, javelinaProxySecretName, axiosOptions)
    }

    /**
     * @description return locations by Block of Business and Client ID.
     * @param {*} blockId
     * @param {*} clientId
     */
    async getLocations(blockId, clientId) {
        await this.createSecureAxiosInstance()

        const params = {
            BlkOfBusID: blockId,
            ClientID: clientId
        }
    
        let path = this.queryParamsToPathParams(params, `pureProxy/core/listLocations`);
    
        const response = await this.secureAxiosInstance.get(path, {
        validateStatus: function (status) {
            return (
                (status >= 200 && status < 300)
                || (status === 404)
            );
        }
        });
    
        if (response.status === 404) {
            return null;
        }

        return response.data.Response;
    }
}

module.exports = JavelinaLocationClient
